import React from 'react';
import { SPEAKER_COUNTS } from '../../lib/recognition/settingsPreference';

/**
 * Выбор «по участникам» и их числа — общий у файла (ReadyState) и ссылки
 * (форма ссылки на пустом экране). Один контрол на оба пути: у ссылки он
 * появился 02.10.2026 (обращение fe94f8a8), и разойтись с файлом в подписях
 * или вариантах числа ему незачем.
 *
 * `settings` — { diarize, numSpeakers, minSpeakers, maxSpeakers }; что из этого
 * уходит в запрос, решает speakerParams (lib/recognition/sources/file.js).
 * `withCount=false` — у стерео-звонка участников разводят каналы, число не
 * спрашиваем.
 */

const SPEAKER_OPTIONS = ['', ...SPEAKER_COUNTS];

// Свой select: у нативного своя рамка и своя стрелка, а в «Бумаге» у контролов
// есть только заливка.
const Select = ({ label, value, onChange, options }) => (
  <select
    aria-label={label}
    value={value === null ? '' : value}
    onChange={(e) => onChange(e.target.value === '' ? null : parseInt(e.target.value, 10))}
    className="appearance-none rounded-badge bg-paper-bg px-[6px] py-[3px] text-[13px] font-semibold text-paper-ink outline-none"
  >
    {options.map((v) => (
      <option key={String(v)} value={v}>{v === '' ? 'Авто' : v}</option>
    ))}
  </select>
);

// Своя галочка: квадрат 16px с обводкой, как в артборде.
const Check = ({ checked, onChange, children, id }) => (
  <button type="button" id={id} onClick={() => onChange(!checked)}
          className="flex items-center gap-2 text-[14px] text-paper-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-paper-accent">
    <span className={`w-4 h-4 rounded-[4px] border-[1.5px] border-paper-ink flex items-center
                      justify-center ${checked ? 'bg-paper-ink' : 'bg-transparent'}`}>
      {checked && (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff"
             strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </span>
    {children}
  </button>
);

const SpeakerSettings = ({ id, settings, onChange, withCount = true }) => (
  <>
    <Check id={id} checked={settings.diarize}
           onChange={(v) => onChange({ ...settings, diarize: v })}>
      По участникам
    </Check>

    {settings.diarize && withCount && (
      <span className="flex items-center gap-2 text-[13px] text-paper-ink-2">
        Участников:
        <Select label="Количество участников" value={settings.numSpeakers}
                onChange={(v) => onChange({ ...settings, numSpeakers: v })}
                options={SPEAKER_OPTIONS} />
        {/* Вилка нужна ровно тогда, когда точного числа нет: модель без
            границ ищет от одного участника до бесконечности. */}
        {settings.numSpeakers === null && (
          <>
            от
            <Select label="Участников не меньше" value={settings.minSpeakers}
                    onChange={(v) => onChange({ ...settings, minSpeakers: v })}
                    options={SPEAKER_OPTIONS} />
            до
            <Select label="Участников не больше" value={settings.maxSpeakers}
                    onChange={(v) => onChange({ ...settings, maxSpeakers: v })}
                    options={SPEAKER_OPTIONS} />
          </>
        )}
      </span>
    )}
  </>
);

export default SpeakerSettings;
